<template>
    <Modal2
        v-if="visible"
        design="v3"
        class-name="bulk-user-modal"
        :show-footer="false"
        :show-title="false"
        @cancel="onCancel"
    >
        <div class="bulk-user-modal-content">
            <div class="modal-section">
                <div class="selection-wrapper">
                    <div class="section-title">
                        <i class="material-icons">group_add</i>
                        <span>Kullanıcı Seçimi</span>
                    </div>

                    <div class="form-field">
                        <label class="field-label">Kullanıcılar</label>
                        <a-select
                            v-model="selectedUsers"
                            mode="multiple"
                            size="large"
                            placeholder="Kullanıcı seçin..."
                            :filter-option="filterOption"
                            show-search
                            class="user-select"
                        >
                            <a-select-option
                                v-for="user in availableUsers"
                                :key="user._id"
                                :value="user._id"
                            >
                                {{ user.name || user.email }}
                            </a-select-option>
                        </a-select>
                        <div class="field-hint">
                            <i class="material-icons">lightbulb_outline</i>
                            <span>Birden fazla kullanıcı seçebilirsiniz</span>
                        </div>
                    </div>
                </div>

                <div v-if="selectedUsers.length > 0" class="preview-section">
                    <div class="preview-header">
                        <div class="header-left">
                            <i class="material-icons">people</i>
                            <span>Seçilen Kullanıcılar</span>
                        </div>
                        <div class="count-badge">{{ selectedUsers.length }}</div>
                    </div>
                    <div class="users-grid">
                        <div 
                            v-for="userId in selectedUsers" 
                            :key="userId" 
                            class="user-card"
                        >
                            <div class="user-avatar">
                                <i class="material-icons">person</i>
                            </div>
                            <div class="user-info">
                                <div class="user-name">{{ getUserName(userId) }}</div>
                            </div>
                            <div class="user-check">
                                <i class="material-icons">check_circle</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <SupsisButton @click="onCancel">İptal</SupsisButton>
                <SupsisButton primary @click="onConfirm">
                    <i class="material-icons">how_to_reg</i>
                    Kullanıcı Ata
                </SupsisButton>
            </div>
        </div>
    </Modal2>
</template>

<script>
import Modal2 from "@/components/common/Modal2.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import { mapState } from "vuex";

export default {
    name: "BulkAssignUserModal",
    components: { Modal2, SupsisButton },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        selectedCount: {
            type: Number,
            default: 0,
        },
    },
    data: function () {
        return {
            selectedUsers: [],
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
        availableUsers: function () {
            return this.users.filter((user) => !user.isDeleted);
        },
    },
    methods: {
        getUserName: function (userId) {
            const user = this.users.find((u) => u._id === userId);
            return user ? user.name || user.email : userId;
        },
        filterOption: function (input, option) {
            const user = this.users.find((u) => u._id === option.key);
            if (!user) return false;
            const name = user.name || user.email || "";
            return name.toLowerCase().includes(input.toLowerCase());
        },
        onConfirm: function () {
            if (this.selectedUsers.length === 0) {
                this.$message.warning("Lütfen en az bir kullanıcı seçiniz");
                return;
            }

            this.$emit("confirm", {
                action: "add-preferred-agents",
                payload: {
                    agentIds: this.selectedUsers,
                },
            });
            this.reset();
        },
        onCancel: function () {
            this.$emit("cancel");
            this.reset();
        },
        reset: function () {
            this.selectedUsers = [];
        },
    },
};
</script>

<style lang="scss">
.bulk-user-modal {
    .custom-modal-body {
        padding: 0 !important;
    }

    .bulk-user-modal-content {
        display: flex;
        flex-direction: column;
        min-height: 450px;

        .modal-section {
            flex: 1;
            padding: 28px;
            overflow-y: auto;
            max-height: calc(80vh - 200px);
        }

        .selection-wrapper {
            margin-bottom: 28px;

            .section-title {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 20px;
                padding-bottom: 12px;
                border-bottom: 2px solid #e8eaed;

                .material-icons {
                    font-size: 24px;
                    color: #22272d;
                }

                span {
                    font-size: 16px;
                    font-weight: 700;
                    color: #22272d;
                    letter-spacing: 0.3px;
                }
            }

            .form-field {
                .field-label {
                    display: block;
                    font-size: 14px;
                    font-weight: 600;
                    color: #495057;
                    margin-bottom: 10px;
                    letter-spacing: 0.3px;
                }

                .user-select {
                    width: 100%;
                }

                .field-hint {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: 10px;
                    font-size: 13px;
                    color: #6c757d;

                    .material-icons {
                        font-size: 16px;
                    }
                }
            }
        }

        .preview-section {
            padding-top: 24px;
            border-top: 2px solid #e8eaed;

            .preview-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 16px;

                .header-left {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    .material-icons {
                        font-size: 22px;
                        color: #22272d;
                    }

                    span {
                        font-size: 15px;
                        font-weight: 700;
                        color: #22272d;
                        letter-spacing: 0.3px;
                    }
                }

                .count-badge {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 32px;
                    height: 32px;
                    padding: 0 12px;
                    background: linear-gradient(135deg, #22272d 0%, #3d4451 100%);
                    color: white;
                    border-radius: 16px;
                    font-size: 14px;
                    font-weight: 700;
                    box-shadow: 0 2px 8px rgba(34, 39, 45, 0.2);
                }
            }

            .users-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
                gap: 12px;
            }

            .user-card {
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 14px 16px;
                background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                border: 1.5px solid #e8eaed;
                border-radius: 12px;
                transition: all 0.3s ease;

                &:hover {
                    border-color: #22272d;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(34, 39, 45, 0.08);
                }

                .user-avatar {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    background: linear-gradient(135deg, #22272d 0%, #3d4451 100%);
                    border-radius: 50%;
                    flex-shrink: 0;

                    .material-icons {
                        font-size: 20px;
                        color: white;
                    }
                }

                .user-info {
                    flex: 1;
                    min-width: 0;

                    .user-name {
                        font-size: 14px;
                        font-weight: 600;
                        color: #22272d;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                .user-check {
                    .material-icons {
                        font-size: 20px;
                        color: #28a745;
                    }
                }
            }
        }

        .modal-footer {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 12px;
            padding: 20px 28px;
            border-top: 2px solid #e8eaed;

            .supsis-button {
                height: 44px;
                padding: 0 24px;
                font-size: 15px;
                border-radius: 10px;
                
                .material-icons {
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
